/**
 * Provides the toast options for the toast notifications.
 * @param {Object} theme The theme object.
 */
const getToastOptions = (theme) => ({
	style: {
		color: theme.palette.common.black,
		borderRadius: theme.shape.borderRadius,
	},
	success: {
		style: {
			background: theme.palette.success.main,
			color: theme.palette.success.contrastText,
			borderRadius: theme.shape.borderRadius,
		},
		iconTheme: {
			primary: theme.palette.success.light,
			secondary: theme.palette.success.dark,
		},
	},
	error: {
		style: {
			background: theme.palette.error.main,
			color: theme.palette.error.contrastText,
			borderRadius: theme.shape.borderRadius,
		},
		iconTheme: {
			primary: theme.palette.error.light,
			secondary: theme.palette.error.dark,
		},
	},
})

export default getToastOptions
